/**
 * Created by BHCDWXM on 2020/9/25
 */
export default {
    namespaced: true,
    state: {
        supplierName: "123",
        logo:"",
        phone:"123456",
    },
    mutations: {
        updateIndex(state, activeIndex) {
            state.activeIndex = activeIndex;
        }
    },
    actions: {
        updateIndex({ state, commit }, route) {
            let item = state.list.find((item) => {
                return item.reg.test(route.path)
            });
            if (item) {
                commit('updateIndex', item.path);
                return;
            }
            commit('updateIndex', null)
        }
    }
}